__turbopack_context__.v({
  "image": "banner-medium-item-module-scss-module__aA2I2W__image",
  "image-wrapper": "banner-medium-item-module-scss-module__aA2I2W__image-wrapper",
});
